import { makeStyles, Button as ButtonBase } from 'vendor/material';
import { type ComponentProps } from 'react';

const useStyles = makeStyles((theme) => ({
  button: {
    '&:disabled': {
      backgroundColor: theme.palette.NEUTRAL020,
      pointer: 'none',
    },
    padding: `7px ${theme.spacing(2)}`,
    height: theme.typography.pxToRem(34),
    flexGrow: 1,
    flexShrink: 0,
    color: theme.palette.BLUE400,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 700,
    textTransform: 'none',
    borderColor: theme.palette.NEUTRAL040,
  },
}));
const WidgetButton = (props: ComponentProps<typeof ButtonBase>) => {
  const classes = useStyles();
  return (
    <ButtonBase
      className={classes.button}
      variant="outlined"
      color="primary"
      size="small"
      {...props}
    />
  );
};

export default WidgetButton;
